import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as ShipmentAddressesActions from './shipment-addresses.actions';
import { ShipmentAddress } from './shipment-addresses.models';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

export const SHIPMENTADDRESSES_FEATURE_KEY = 'shipmentAddresses';

export interface State extends EntityState<ShipmentAddress> {
    selectedId?: string | number; // which ShipmentAddresses record has been selected
    loading: boolean; // has the ShipmentAddresses list been loaded
    error?: string | null; // last known error (if any)
    shipment?: Shipment;
}

export interface ShipmentAddressesPartialState {
    readonly [SHIPMENTADDRESSES_FEATURE_KEY]: State;
}

export const shipmentAddressesAdapter: EntityAdapter<ShipmentAddress> =
    createEntityAdapter<ShipmentAddress>();

export const initialState: State = shipmentAddressesAdapter.getInitialState({
    // set initial required properties
    loading: false,
});

const shipmentAddressesReducer = createReducer(
    initialState,
    // eslint-disable-next-line no-empty-pattern
    on(ShipmentAddressesActions.init, (state, {}) => ({
        ...state,
        loading: true,
        error: null,
        selectedId: null,
    })),
    on(
        ShipmentAddressesActions.loadShipmentAddressesSuccess,
        (state, { shipmentAddresses }) =>
            shipmentAddressesAdapter.setAll(shipmentAddresses, {
                ...state,
                loading: false,
            })
    ),
    on(ShipmentAddressesActions.updateShipmentAddress, state => ({
        ...state,
        loading: true,
    })),
    on(
        ShipmentAddressesActions.updateShipmentAddressesSuccess,
        (state, { shipmentAddress }) =>
            shipmentAddressesAdapter.setOne(shipmentAddress, {
                ...state,
                loading: false,
                selectedId: null,
            })
    ),
    on(
        ShipmentAddressesActions.loadShipmentAddressesFailure,
        ShipmentAddressesActions.updateShipmentAddressesFailure,
        (state, { error }) => ({ ...state, error, loading: false })
    ),
    on(
        ShipmentAddressesActions.selectShipmentAddress,
        (state, { shipmentAddress }) => ({
            ...state,
            selectedId: shipmentAddress.id,
        })
    ),
    on(ShipmentAddressesActions.unselectShipmentAddress, state => ({
        ...state,
        selectedId: null,
    })),
    on(ShipmentAddressesActions.reset, () => initialState)
);

export function reducer(state: State | undefined, action: Action) {
    return shipmentAddressesReducer(state, action);
}
